exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container-details[data-v-12ca601c]{border:1px solid #ccc;border-radius:8px;padding:20px;margin-bottom:20px}.header[data-v-12ca601c]{display:flex;justify-content:space-between;margin-bottom:20px}.alerts[data-v-12ca601c]{margin-bottom:20px}.alert[data-v-12ca601c]{color:#d9534f;padding:10px;background-color:#f2dede;border:1px solid #ebccd1;border-radius:4px;margin-bottom:10px}.details[data-v-12ca601c]{border-top:1px solid #eee;padding-top:20px}.label[data-v-12ca601c]{font-weight:700}.invalid-date[data-v-12ca601c]{background-color:#fff}.Invalid[data-v-12ca601c]{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-12ca601c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/ocean-insights/ContainerDetails.vue
// module id = 1396
// module chunks = 0